import { filterSelectTriggerClassName } from "@/components/dashboard/active-filters-bar";
import { Label } from "@/components/ui/label";
import { Select } from "@/components/ui/select";

const ALL_AMS_VALUE = "__all__";

interface AmsFilterProps {
  selectedAms: string | null;
  onSelectedAmsChange: (ams: string | null) => void;
  amsOptions: Array<{ value: string; label: string }>;
}

export function AmsFilter({
  selectedAms,
  onSelectedAmsChange,
  amsOptions,
}: AmsFilterProps) {
  if (amsOptions.length === 0) {
    return null;
  }

  const options = [{ value: ALL_AMS_VALUE, label: "All AMS" }, ...amsOptions];

  const value = selectedAms ? [selectedAms] : [ALL_AMS_VALUE];

  const handleChange = (values: string[]) => {
    const next = values[0];
    onSelectedAmsChange(next && next !== ALL_AMS_VALUE ? next : null);
  };

  return (
    <div className="w-full shrink-0 md:w-64 md:max-w-full">
      <Label htmlFor="ams-filter" className="mb-2 block font-bold">
        Filter by AMS
      </Label>
      <Select
        options={options}
        value={value}
        onValueChange={handleChange}
        multiple={false}
        placeholder="All AMS"
        searchPlaceholder="Search AMS..."
        emptyMessage="No AMS found."
        buttonVariant="default"
        className={filterSelectTriggerClassName(Boolean(selectedAms))}
      />
    </div>
  );
}
